module.exports = __webpack_public_path__ + "img/thumb-agus-haryadi.44203950.png";